var map = {
	"./Mask.png": "bkoR",
	"./about/chenquan.png": "bsJq",
	"./about/chenxiansen.png": "4l+/",
	"./about/diaohaifeng.png": "yvQI",
	"./about/dongyuexing.png": "bWOY",
	"./about/duyingjie.png": "3Mph",
	"./about/guxiulian.png": "0Wzf",
	"./about/huangxiangyang.png": "xWun",
	"./about/jigou5.png": "cxC3",
	"./about/kongyufang.png": "vGna",
	"./about/lihongfen.png": "6pz9",
	"./about/linyuanhe.png": "Be74",
	"./about/liuying.png": "i+fX",
	"./about/luxin.png": "ApQK",
	"./about/niming.png": "y4l1",
	"./about/songtiepeng.png": "tt6J",
	"./about/sunjianguo.png": "SBLY",
	"./about/yanggensheng.png": "go9C",
	"./about/youdexin.png": "GRgH",
	"./about/zhangxiaolin.png": "B2G9",
	"./about/zhouhuiyi.png": "kffM",
	"./about/zuzhijigou.png": "8N/N",
	"./gongan.png": "aDkJ",
	"./header.png": "C/5X",
	"./icon_download7a.png": "863L",
	"./icon_downloadff.png": "dZdD",
	"./icon_print7a.png": "72Qs",
	"./icon_printff.png": "4XKm",
	"./kefu-hover.png": "icQb",
	"./kefu.png": "mjJX",
	"./leftarrow.png": "5PIR",
	"./logo.png": "7Otq",
	"./newsnav_img1.png": "hoVA",
	"./old_age_education/lesson-icon.png": "USB0",
	"./old_age_education/lesson-icon2-played.png": "C8iC",
	"./old_age_education/lesson-icon2.png": "WBpC",
	"./old_age_education/lesson-poster.png": "76KT",
	"./old_age_education/video-btn.png": "UFNV",
	"./online_service/code.png": "y/IK",
	"./online_service/download-icon.png": "TH8f",
	"./online_service/pdf.png": "QiU6",
	"./online_service/register-code.png": "i18d",
	"./online_service/word.png": "F4mE",
	"./online_service/xls.png": "AFDT",
	"./qrcode.png": "jWhC",
	"./rightarrow.png": "Jdnw",
	"./tip.png": "RAvV",
	"./wslndx/diaohaifeng.png": "c7a5",
	"./wslndx/kuangzhengfei.png": "qwo7",
	"./wslndx/liaojinling.png": "3zYB",
	"./wslndx/lichunhua.png": "E256",
	"./wslndx/tianguihua.png": "DijK",
	"./xiazai.png": "RYgU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 1